const socialIconData = [
  {
    name: 'linkedin',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/linkedin-black.svg',
    url: 'https://www.linkedin.com/company/lucidsoftware',
    label: 'Go to Lucid on LinkedIn',
  },
  {
    name: 'twitter',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/Footer/twitter-x-logo-black.svg',
    url: 'https://www.twitter.com/Lucidsoftware',
    label: 'Go to Lucid on Twitter',
  },
  {
    name: 'instagram',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/instagram-black.svg',
    url: 'https://www.instagram.com/lucidsoftware',
    label: 'Go to Lucid on Instagram',
  },
  {
    name: 'facebook',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/facebook-black.svg',
    url: 'https://www.facebook.com/lucidsoftware',
    label: 'Go to Lucid on Facebook',
  },
  {
    name: 'youtube',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/youtube-black.svg',
    url: 'https://www.youtube.com/channel/UCnd94o169CbOIJyiEUkTL2A',
    label: 'Go to Lucid on YouTube',
  },
  {
    name: 'glassdoor',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/glassdoor-black.svg',
    url: 'https://www.glassdoor.com/Overview/Working-at-Lucid-Software-EI_IE636868.11,25.htm',
    label: 'Go to Lucid on Glassdoor',
  },
  {
    name: 'tiktok',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/Footer/TikTok-Social-logo-Black.svg',
    url: 'https://www.tiktok.com/@lucid_software',
    label: 'Go to Lucid on TikTok',
  },
];

const socialIconDataEdu = [
  {
    name: 'facebook',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/facebook-black.svg',
    url: 'https://www.facebook.com/lucid4edu',
    label: 'Go to Lucid for Education on Facebook',
  },
  {
    name: 'twitter',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/Footer/twitter-x-logo-black.svg',
    url: 'https://www.twitter.com/Lucid4Edu',
    label: 'Go to Lucid for Education on Twitter',
  },
  {
    name: 'youtube',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/youtube-black.svg',
    url: 'https://www.youtube.com/channel/UC9Q96YmfxmrkG9hfzSklTog',
    label: 'Go to Lucid for Education on YouTube',
  },
  {
    name: 'linkedin',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/linkedin-black.svg',
    url: 'https://www.linkedin.com/company/lucid4edu',
    label: 'Go to Lucid for Education on LinkedIn',
  },
  {
    name: 'pinterest',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/pinterest-black.svg',
    url: 'https://www.pinterest.com/lucid4edu',
    label: 'Go to Lucid for Education on Pinterest',
  },
  {
    name: 'instagram',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/footer/instagram-black.svg',
    url: 'https://www.instagram.com/lucid4edu',
    label: 'Go to Lucid for Education on Instagram',
  },
  {
    name: 'tiktok',
    logo: 'https://cdn-cashy-static-assets.lucidchart.com/marketing/pages/chart/Footer/TikTok-Social-logo-Black.svg',
    url: 'https://www.tiktok.com/@lucid_software',
    label: 'Go to Lucid on TikTok',
  },
];

export { socialIconDataEdu };

export default socialIconData;
